import { useCallback, useEffect } from 'react';

import { AppStateStatus } from 'react-native';

import Orientation from 'react-native-orientation-locker';

import { ORIENTATION, useDeviceOrientationEffect } from 'utils/orientation';
import { isPhone } from 'utils/responsiveness';

import useNoInternetAlertVisible from 'components/NoInternetAlert/hooks/useNoInternetAlertVisible';

type Props = {
    focused: boolean;
    appState: AppStateStatus;
    showPinDialog: boolean;
    fullscreen: boolean;
    isCastConnected: boolean;
    onShowFullscreen: (orientation: ORIENTATION) => void;
    onCloseFullscreen: () => void;
};

export default function useEmbeddedPlayerOrientation({
    focused,
    appState,
    showPinDialog,
    fullscreen,
    isCastConnected,
    onShowFullscreen,
    onCloseFullscreen,
}: Props) {
    const { visible: noInternetAlertVisible } =
        useNoInternetAlertVisible(false);

    useEffect(() => {
        if (isCastConnected && fullscreen) {
            onCloseFullscreen();
        }
    }, [isCastConnected]);

    const handleOrientationChange = useCallback(
        (orientation) => {
            if (
                isPhone &&
                focused &&
                appState === 'active' &&
                !showPinDialog &&
                !noInternetAlertVisible &&
                !isCastConnected
            ) {
                Orientation.getAutoRotateState((autoRotateEnabled) => {
                    if (autoRotateEnabled) {
                        switch (orientation) {
                            case ORIENTATION.LANDSCAPE_LEFT:
                            case ORIENTATION.LANDSCAPE_RIGHT:
                                onShowFullscreen(orientation);
                                break;
                            case ORIENTATION.PORTRAIT:
                                onCloseFullscreen();
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
        },
        [
            showPinDialog,
            focused,
            appState,
            noInternetAlertVisible,
            isCastConnected,
            onShowFullscreen,
            onCloseFullscreen,
        ],
    );

    useDeviceOrientationEffect(handleOrientationChange);
}
